import { useEffect, useState } from 'react';

export function useGetOrgInfo(orgId) {
  const [org, setOrg] = useState({});

  const updateOrg = (data) => {
    setOrg(prevState => ({ ...prevState, ...data}));
  };

  useEffect(() => {
    const doFetch = async () => {
      const d = await fetch(`/api/v1/organizations/${orgId}`);
      const data = await d.json();
      setOrg(data['organization']);
    };
    doFetch();
    // eslint-disable-next-line
  }, []);
  return [org, updateOrg];
}
